var Enum = Enum || {};

Enum.MEEDY.DISEASE_TYPE = {
  ILLNESS: 'ILLNESS',
  INJURY: 'INJURY'
};

Object.freeze(Enum.MEEDY.DISEASE_TYPE);